// Wordmark — typographic, with gradient diamond shape (Incubatour DNA).
export const Wordmark = ({ tone = "dark", compact = false }) => {
  const isLight = tone === "light";
  const text = isLight ? "var(--ix-cream)" : "var(--ix-night)";
  const muted = isLight ? "rgba(251,247,238,0.55)" : "rgba(11,14,30,0.55)";
  return (
    <div className="flex items-center gap-3" data-testid="wordmark">
      {/* Mini diamond stack — nod to Incubatour logo */}
      <span className="relative inline-block" aria-hidden style={{ width: 18, height: 22 }}>
        <span
          className="absolute"
          style={{
            top: 0, left: 4, width: 12, height: 16,
            background: "linear-gradient(135deg, #FF1F8F 0%, #FCB424 100%)",
            clipPath: "polygon(22% 0%, 100% 0%, 78% 100%, 0% 100%)",
          }}
        />
        <span
          className="absolute"
          style={{
            bottom: 0, left: 0, width: 11, height: 14,
            background: "linear-gradient(135deg, #FCB424 0%, #8AE52E 100%)",
            clipPath: "polygon(22% 0%, 100% 0%, 78% 100%, 0% 100%)",
            opacity: 0.92,
          }}
        />
      </span>

      <div className="flex items-baseline gap-2">
        <span
          className="ix-display"
          style={{
            color: text,
            fontWeight: 700,
            fontSize: compact ? "1.05rem" : "1.18rem",
            letterSpacing: "-0.03em",
            lineHeight: 1,
          }}
        >
          Incubatour
        </span>
        {!compact && (
          <span
            className="ix-mono"
            style={{
              color: muted,
              fontSize: "0.62rem",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              paddingLeft: 8,
              borderLeft: `1px solid ${muted}`,
            }}
          >
            Experiences Lab
          </span>
        )}
      </div>
    </div>
  );
};

export default Wordmark;
